import { create } from 'zustand';

type EditorState = {
  language: string;
  setLanguage: (language: string) => void;
};

export const useEditorStore = create<EditorState>((set) => ({
  language: 'typescript',
  setLanguage: (language) => set({ language }),
}));